import { React } from '../../libraries/index';
const CustomModal = ({ text }) => {
  return <>{text}</>;
};
export default CustomModal;